import "./share.css";
import { Row, Col, Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { Sharemodal } from "../../constants/jsonConstant";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ChatIcon from "@mui/icons-material/Chat";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { getAsset } from "../../helpers/helper";

import Massagemodalshare from "./Massagemodalshare"; // ✅ New modal component
import FacebookIcon from "@mui/icons-material/Facebook";
import { useTrackShareMutation, useGetShopByIdQuery } from "../../features/shop/shopApiSlice";

const ShareModel = ({
  show,
  handleClosemodal,
  handleShowshare,
  shareurl = "",
  shopid,
  shopTitle = "",
  shopDesc = "",
  shopImage = "",
  // Some pages (e.g. a single property/item view) share a URL whose last
  // path segment is that ITEM's own id — which happens to be the same
  // length as a shop id, so the auto-detection below would wrongly treat
  // it as one and build a broken "/api/shop/share/:id" link. Let callers
  // that know their URL doesn't point at a shop profile opt out.
  disableShopAutoDetect = false,
}) => {
  const [showMessengerModal, setShowMessengerModal] = useState(false);
  const [trackShare] = useTrackShareMutation();
  const authUser = useSelector((state) => state.auth?.user);
  const persistedUser = useSelector((state) => state.user?.name);
  const currentUser = authUser || persistedUser;
  const fullName =
    typeof currentUser === "string"
      ? currentUser
      : currentUser?.fullname || currentUser?.name || "";

  const safeShareUrl = shareurl || "";
  // Use the local URL from .env, or fallback to the current origin
  const baseUrl = process.env.REACT_APP_URL || window.location.origin;

  const getLocalFullUrl = (url) => {
    if (!url) return baseUrl;

    try {
      const parsed = new URL(url);
      return `${baseUrl}${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
      const normalizedPath = url.startsWith("/") ? url : `/${url}`;
      return `${baseUrl}${normalizedPath}`;
    }
  };

  // Extract shopId from shareurl if not explicitly passed
  const resolvedShopId = shopid || (disableShopAutoDetect ? "" : (() => {
    if (!safeShareUrl) return "";
    const parts = safeShareUrl.split("/");
    const lastPart = parts[parts.length - 1];
    return lastPart && (lastPart.length === 24 || lastPart.length === 6) ? lastPart : "";
  })());

  // Fetch shop details dynamically if missing
  const { data: shopDetailsRes } = useGetShopByIdQuery(resolvedShopId, {
    skip: !resolvedShopId || (!!shopTitle && !!shopDesc && !!shopImage),
  });

  const shopDetails = shopDetailsRes?.data?.Shop || {};
  const activeTitle = shopTitle || shopDetails.shopname || "";
  const activeDesc = shopDesc || shopDetails.description || "";
  const activeImage = shopImage || (shopDetails.image && shopDetails.image[0]) || "";

  // If resolvedShopId is present, the share link points to the backend dynamic OG redirect page
  const apiBaseUrl = process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL
    : "http://localhost:8080/api";

  const fullUrl = resolvedShopId
    ? `${apiBaseUrl.replace(/\/api\/?$/, "")}/api/shop/share/${resolvedShopId}`
    : getLocalFullUrl(safeShareUrl);

  const getFullAssetUrl = (assetPath) => {
    if (!assetPath) return "";
    const resolvedAsset = getAsset(assetPath);
    if (!resolvedAsset) return "";
    if (resolvedAsset.startsWith("http://") || resolvedAsset.startsWith("https://")) {
      return resolvedAsset;
    }
    const assetBaseUrl = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace("/api", "") : "http://localhost:8080";
    const cleanAsset = resolvedAsset.startsWith("/") ? resolvedAsset : `/${resolvedAsset}`;
    return `${assetBaseUrl}${cleanAsset}`;
  };

  const shopImageUrl = getFullAssetUrl(activeImage);

  // Dynamically update document headers / meta tags for social media crawler support in client
  useEffect(() => {
    if (show && activeTitle) {
      document.title = activeTitle;

      const setMetaTag = (property, content, attr = "property") => {
        if (!content) return;
        let meta = document.querySelector(`meta[${attr}="${property}"]`);
        if (!meta) {
          meta = document.createElement("meta");
          meta.setAttribute(attr, property);
          document.head.appendChild(meta);
        }
        meta.setAttribute("content", content);
      };

      setMetaTag("og:title", activeTitle);
      setMetaTag("og:description", activeDesc);
      setMetaTag("og:image", shopImageUrl);
      setMetaTag("og:url", fullUrl);

      setMetaTag("description", activeDesc, "name");
      setMetaTag("twitter:card", "summary_large_image", "name");
      setMetaTag("twitter:title", activeTitle, "name");
      setMetaTag("twitter:description", activeDesc, "name");
      setMetaTag("twitter:image", shopImageUrl, "name");
    }
  }, [show, activeTitle, activeDesc, shopImageUrl, fullUrl]);

  const getShareText = () => {
    let text = "Check out this profile on Select Ezi!";
    if (activeTitle) {
      text = `Check out "${activeTitle}" on Select Ezi!`;
      if (activeDesc) {
        text += `\nDescription: ${activeDesc}`;
      }
    }
    return text;
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      toast.success("Link copied!", {
        position: "bottom-center",
        autoClose: 1500,
      });
      if (resolvedShopId) {
        trackShare({ shopid: resolvedShopId, platform: "other" }).unwrap().catch(err => console.error("Failed to track share:", err));
      }
    } catch (err) {
      console.error("Failed to copy: ", err);
      toast.error("Failed to copy");
    }
  };

  const isMarketer = localStorage.getItem("MeAsmarketerId");

  const handleShareClick = (e) => {
    const shareText = getShareText();
    if (resolvedShopId) {
      trackShare({ shopid: resolvedShopId, platform: "other" }).unwrap().catch(err => console.error("Failed to track share:", err));
    }
    if (e.id === 1) {
      handleClosemodal();
      handleShowshare();
      localStorage.setItem("ShareUrl", fullUrl);
    } else if (e.id === 2) {
      // Telegram
      const msg = shopImageUrl ? `${shareText}\nImage: ${shopImageUrl}` : shareText;
      window.open(
        `https://t.me/share/url?url=${encodeURIComponent(fullUrl)}&text=${encodeURIComponent(msg)}`,
        "_blank"
      );
    } else if (e.id === 3) {
      // Twitter
      window.open(
        `https://twitter.com/intent/tweet?url=${encodeURIComponent(fullUrl)}&text=${encodeURIComponent(shareText)}`,
        "_blank"
      );
    } else if (e.id === 4) {
      // WhatsApp
      const msg = shopImageUrl ? `${shareText}\nImage: ${shopImageUrl}` : shareText;
      window.open(
        `https://api.whatsapp.com/send?text=${encodeURIComponent(`${msg}\nLink: ${fullUrl}`)}`,
        "_blank"
      );
    } else if (e.id === 5) {
      // Email
      const bodyMsg = shopImageUrl ? `${shareText}\n\nImage: ${shopImageUrl}\n\nLink: ${fullUrl}` : `${shareText}\n\nLink: ${fullUrl}`;
      window.open(
        `mailto:?subject=${encodeURIComponent(activeTitle || "Select Ezi Profile Link")}&body=${encodeURIComponent(bodyMsg)}`,
        "_self"
      );
    }
  };

  return (
    <>
      {/* ================= MAIN SHARE MODAL ================= */}
      <Modal show={show} onHide={handleClosemodal} animation={false}>
        <Modal.Header closeButton>
          <h6>Share with {fullName ? <span>{fullName}</span> : <span>your account</span>}</h6>
        </Modal.Header>

        <Modal.Body>
          <Row className="justify-content-center">
            {Sharemodal.map((e) => (
              <Col lg="2" md="2" sm="2" xs="2" key={e.id}>
                <div
                  className="img_hover_box cursor_P"
                  onClick={() => handleShareClick(e)}
                >
                  <img src={e.icon} alt={e.text} />
                </div>
                <p className="font_small text-center">{e.text}</p>
              </Col>
            ))}

            {/* Facebook Share Icon */}
            {resolvedShopId && (
              <Col lg="2" md="2" sm="2" xs="2">
                <div
                  className="img_hover_box cursor_P d-flex justify-content-center align-items-center"
                  onClick={() => {
                    window.open(
                      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(fullUrl)}`,
                      "_blank"
                    );
                    trackShare({ shopid: resolvedShopId, platform: "facebook" }).unwrap().catch(err => console.error("Failed to track share:", err));
                  }}
                >
                  <FacebookIcon fontSize="large" sx={{ color: "#1877F2" }} />
                </div>
                <p className="font_small text-center">Facebook</p>
              </Col>
            )}

            {/* ✅ Conditional Messenger Icon */}
            {isMarketer && (
              <Col lg="2" md="2" sm="2" xs="2">
                <div
                  className="img_hover_box cursor_P d-flex justify-content-center align-items-center"
                  onClick={() => {
                    handleClosemodal();
                    setShowMessengerModal(true);
                  }}
                >
                  <ChatIcon fontSize="large" color="primary" />
                </div>
                <p className="font_small text-center">Messenger</p>
              </Col>
            )}
          </Row>

          <p className="font_11 text-center">
            <b>Share with URL Link</b>
          </p>

          <Row className="font_14 p-2 link_bg align-items-center mx-1">
            <Col lg="10" md="10" xs="10" className="text-start pe-0">
              <div className="share-url-text" title={fullUrl}>
                {fullUrl}
              </div>
            </Col>

            <Col lg="2" md="2" xs="2" className="text-end ps-0">
              <ContentCopyIcon
                className="cursor_P fs-6"
                color="primary"
                onClick={handleCopy}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      {/* ================= MESSENGER MODAL ================= */}
      <Massagemodalshare
        show={showMessengerModal}
        handleClose={() => setShowMessengerModal(false)}
        url={fullUrl}
        shopid={resolvedShopId}
      />
    </>
  );
};

export default ShareModel;